module.exports = __webpack_public_path__ + "static/media/minted.9c9461ce.png";